import { pick } from 'ramda';

const whiteListProps = (props, propTypes) => pick([...Object.keys(propTypes), 'id', 'data-id', 'className'], props);

export default whiteListProps;
